import tinycolor from 'tinycolor2';
import { themeGet } from '@styled-system/theme-get';
import theme from './theme';
/**
 * Gets theme color from palette, using props.color as the palette color
 * @param {*} path - could be shade (base) or pathTo (border.base)
 * @example getPaletteColor('base')(props) => will return theme.palette[props.color].base
 * @example getPaletteColor('border.base')(props) => will return theme.palette.border.base
 */

export const getPaletteColor = path => props => {
  let {
    color = 'primary'
  } = props;
  let shade = path; // default one word

  const pathSplitted = path.split('.');

  if (pathSplitted.length > 1) {
    [color, shade] = pathSplitted;
  }

  return themeGet(`palette.${color}.${shade}`)(props);
};
/**
 * Gets theme color from palette.text
 * @param {*} shade - palette > color > shade
 * @example getTextColor('light')(props) => will return theme.palette.text.light
 */

export const getTextColor = shade => props => {
  return getPaletteColor(`text.${shade}`)(props);
};
export const getBackgroundColor = shade => props => {
  return getPaletteColor(`background.${shade}`)(props);
};
export const getBorderColor = shade => props => {
  return getPaletteColor(`border.${shade}`)(props);
};
export const getAlertColor = path => props => {
  return themeGet(`palette.alert.${path}`)(props);
};
export const getMediaQuery = size => props => {
  const queries = themeGet('mediaQueries')(props) || {};
  return queries[size];
};
export const getFontSize = (size, fallbackSize = 1) => props => themeGet(`fontSizes.${size}`)(props) || themeGet(`fontSizes.${fallbackSize}`)(props);
export const getTextContrast = (shade, scale) => props => {
  if (shade) {
    const light = tinycolor(scale == null ? void 0 : scale.light).isValid() ? scale == null ? void 0 : scale.light : getTextColor(scale == null ? void 0 : scale.light)(props);
    const dark = tinycolor(scale == null ? void 0 : scale.dark).isValid() ? scale == null ? void 0 : scale.dark : getTextColor(scale == null ? void 0 : scale.dark)(props);
    if (shade.toString().includes('transparent')) return dark || getTextColor('dark')(props);
    const background = getBackgroundColor(shade)(props) || getPaletteColor(shade)(props) || shade;
    const color = tinycolor(background);

    if (color.isValid() && dark && light) {
      return color.isLight() ? dark : light;
    }
  }

  return getTextColor('dark')(props);
};
export const getColorHelpers = tinycolor;
export { themeGet };
/** @returns {String[]} Theme colors's names */

export const getThemeColors = () => Object.keys(theme.colors);
/** @returns {String[]} Theme palette's color names */

export const getThemeColorsFromPalette = () => Object.entries(theme.palette).reduce((acc, [parent, child]) => [...acc, ...Object.keys(child).map(color => `${parent}.${color}`)], []);
export const getBoxShadows = shadowIndex => props => themeGet(`boxShadows.${shadowIndex}`)(props);
export const darken = (color, amount) => tinycolor(color).darken(amount).toString();